import { flatten, isEqual } from 'lodash';
import { ElementTypeUtils } from "core/helpers/ElementTypeUtils";

type Element = {
  id: string;
  type: string;
  parent?: Element;
  children?: Element[];
};

type ElementData = {
  id: string;
  element: { id: string };
  data?: any;
};

type Section = Record<string, Element>;
type Values = Record<string, any>;

export function buildFormPayload(
  ecrfId: string,
  sectionElements: any[],
  ecrfElementData: any[],
  values: Values
) {
  const buildPayload = (element: Element, value: any, found: ElementData | undefined) => {
    // const data = (Array.isArray(value) ? value : [value]).flat();
    const data = flatten(Array.isArray(value) ? value : [value]);

    // skip empty values
    const isEmpty =
      data.length === 0 ||
      data.every((v) => v === null || v === undefined || v === '');

    if (isEmpty) return null;

    // skip same data values
    if (found && isEqual(data, found.data)) {
      return null;
    }

    return found
      ? {
        "@id": `/api/element_datas/${found.id}`,
        data,
      } : {
        ecrf: `/api/ecrves/${ecrfId}`,
        element: `/api/elements/${element.id}`,
        data,
      };
  };

  return Object.values(sectionElements)
    .filter(el => !ElementTypeUtils.isIndividuallySaved(el.type))
    .flatMap(el => {
      const children = Array.isArray(el.children) ? el.children : [];

      if (children.length > 0) {
        return children
          .filter((child: any) => !ElementTypeUtils.isIndividuallySaved(child.type))
          .map((child: any) => {
            const found = ecrfElementData.find(e => e?.element?.id === child.id);
            const value = values[child.id];
            return buildPayload(child, value, found);
          })
          .filter(Boolean); // remove nulls
      }

      const found = ecrfElementData.find(e => e?.element?.id === el.id);
      const value = values[el.id];
      return [buildPayload(el, value, found)].filter(Boolean);
    });
}
